import User from "@shared/Core/Models/User";

export function getUserDisplayName(user: User) {
    return user.nickname && user.nickname.length > 0
        ? user.nickname
        : `${user.firstName} ${user.lastName}`;
}